// @ts-strict-ignore
import type { Viewport } from 'react-flow-renderer';
import type { WorkflowState } from './state';
import type { PublicId, SchemaInstance, WorkflowProps } from '../engine/types';

// todo - think about moving this to the graph dir
export type CanvasRect = {
  x: Viewport['x'];
  y: Viewport['y'];
  zoom: Viewport['zoom'];
  width: DOMRect['width'];
  height: DOMRect['height'];
};

export type CanvasProperties = {
  isMoving: boolean;
  rect: CanvasRect;
};

export type NodeConnectorInteractionState = 'hovered' | 'focused';
export type NodeConnectorIntent = 'link' | 'add';

export type DerivedNodeConnectorState = WorkflowState['ui']['connector'] & {
  /**
   * this field is related to the connector state, but can be derived from the existing
   * store values, so we do not keep it in the store.
   */
  intent: NodeConnectorIntent;
};

export type Snapshot<T> = {
  snapshotId: PublicId;
  data: T;
};

export type WorkflowSnapshots = {
  workflowData: {
    history: {
      initial: Snapshot<Partial<SchemaInstance>>;
      past: Snapshot<Partial<SchemaInstance>>[];
    };
  };
  workflowProps: {
    history: {
      initial: Snapshot<WorkflowProps>;
    };
  };
};

export const snippetMode = {
  pastePending: 'pastePending',
  preview: 'preview',
  review: 'review',
} as const;

export type SnippetMode = keyof typeof snippetMode;

export const snippetOperation = {
  insertSnippet: 'insertSnippet',
  insertLinkedSnippet: 'insertLinkedSnippet',
  upgradeLinkedSnippet: 'upgradeLinkedSnippet',
} as const;

export type SnippetOperation = keyof typeof snippetOperation;

export type SnippetActiveOperation = {
  operation: SnippetOperation | null;
  snippetActionPublicId: PublicId | null;
};
